import { FC } from 'react';
import { InnerIconProps, withIcon } from '@tempusfinance/common-ui';

const RightChevronComponent: FC<InnerIconProps> = ({ size, color }) => {
  const colorVar = `var(--icon-color, var(${color}))`;

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="nostra__icon nostra__icon__rightChevron"
      width={size}
      height={size}
      viewBox="0 0 17 16"
      fill="none"
    >
      <path
        d="M6.75 12L10.75 8L6.75 4"
        stroke={colorVar}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export const RightChevron = withIcon(RightChevronComponent);
